import { useEffect, useState } from 'react';

import './App.css';
import './normalize.css';
import conf from '../package.json';

import MarbleSkip from './MarbleSkip';


const version = conf.version;

function App() {
  const [year, setYear] = useState('2023');
  

  useEffect(() => {
    const currYear = new Date().getFullYear();
    if ( currYear > 2023) {
      setYear(`2023 - ${currYear}`);
    }
  }, []);

  return (
    <div className="mainwrapper">
      <header>
        <div className="header-wrap">
          <div className="header-img">
            <div className="marble-logo"></div>
          </div>
          <div className="header-txt">Marble Skip Solitaire</div>
          <div className="spacer"></div>
          <div className="header-navigate" id="navigate">
            <a className="nav-item" href="https://hiteshlala.com">Home</a>
          </div>
        </div>
      </header>

      <MarbleSkip />

      <div className="spacer"></div>

      <footer>
        <div>
          <p>
            V.{version} <a href="https://hiteshlala.com"> &copy; Hitesh Lala</a> <span id="year">{year}</span>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
